// extracted by mini-css-extract-plugin
export default {"root":"ClassroomResourcePage-module--root--a93ea","downloads":"ClassroomResourcePage-module--downloads--4f038"};